/**
 * @generated SignedSource<<23f506524ab8adcc8e41cce9a5c7483d>>
 * @relayHash e496e22d7f36d52b32407074fdf9e810
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/581.0.0-2026-10-16T16:50:05.386Z/SharedContactDealerWrapperRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type SharedContactDealerWrapperRefetchQuery$variables = {
  fetchUser: boolean;
  itemId: string;
  itemQuantity?: number | null;
  userCountryCode?: string | null;
  userId: string;
  userZipCode?: string | null;
};
export type SharedContactDealerWrapperRefetchQuery$data = {
  readonly viewer: {
    readonly relevantShipping: {
      readonly quoteRequestStatus: string | null;
      readonly shipment: {
        readonly shippingAddress: {
          readonly displayCityStateCountry: string | null;
        } | null;
      } | null;
      readonly shipmentQuote: {
        readonly buyerServiceMethodDisplay: string | null;
        readonly handlingTimeDisplay: string | null;
        readonly serviceMethod: {
          readonly serviceMethodType: string | null;
          readonly serviceType: string | null;
        } | null;
        readonly showQuoteAsPending: boolean | null;
        readonly subTotalAmount: {
          readonly convertedAmountList: ReadonlyArray<{
            readonly amount: number | null;
            readonly currency: Currency | null;
          } | null> | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoLink_shipmentQuote">;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoLink_viewer">;
  };
};
export type SharedContactDealerWrapperRefetchQuery = {
  response: SharedContactDealerWrapperRefetchQuery$data;
  variables: SharedContactDealerWrapperRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemQuantity"
},
v3 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v5 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userZipCode"
},
v6 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v7 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v8 = [
  (v6/*:: as any*/),
  {
    "kind": "Variable",
    "name": "countryCode",
    "variableName": "userCountryCode"
  },
  (v7/*:: as any*/),
  {
    "kind": "Variable",
    "name": "quantity",
    "variableName": "itemQuantity"
  },
  {
    "kind": "Variable",
    "name": "zipCode",
    "variableName": "userZipCode"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quoteRequestStatus",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "displayShort",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "handlingTimeDisplay",
  "storageKey": "handlingTimeDisplay(displayShort:true)"
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "subTotalAmount",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "convertedAmountList",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buyerServiceMethodDisplay",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showQuoteAsPending",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceType",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceMethodType",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayCityStateCountry",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SharedContactDealerWrapperRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedShippingInfoLink_viewer"
          },
          {
            "alias": null,
            "args": (v8/*:: as any*/),
            "concreteType": "RelevantShippingInfo",
            "kind": "LinkedField",
            "name": "relevantShipping",
            "plural": false,
            "selections": [
              (v9/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "kind": "LinkedField",
                "name": "shipmentQuote",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedShippingInfoLink_shipmentQuote"
                  },
                  (v10/*:: as any*/),
                  (v11/*:: as any*/),
                  (v12/*:: as any*/),
                  (v13/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShipmentServiceMethod",
                    "kind": "LinkedField",
                    "name": "serviceMethod",
                    "plural": false,
                    "selections": [
                      (v14/*:: as any*/),
                      (v15/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Shipment",
                "kind": "LinkedField",
                "name": "shipment",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "shippingAddress",
                    "plural": false,
                    "selections": [
                      (v16/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*:: as any*/),
      (v1/*:: as any*/),
      (v5/*:: as any*/),
      (v3/*:: as any*/),
      (v0/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "SharedContactDealerWrapperRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v6/*:: as any*/),
                  (v7/*:: as any*/)
                ],
                "concreteType": "Conversation",
                "kind": "LinkedField",
                "name": "buyerItemConversation",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serviceId",
                    "storageKey": null
                  },
                  (v17/*:: as any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "alias": null,
            "args": (v8/*:: as any*/),
            "concreteType": "RelevantShippingInfo",
            "kind": "LinkedField",
            "name": "relevantShipping",
            "plural": false,
            "selections": [
              (v9/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "kind": "LinkedField",
                "name": "shipmentQuote",
                "plural": false,
                "selections": [
                  (v13/*:: as any*/),
                  (v10/*:: as any*/),
                  (v11/*:: as any*/),
                  (v12/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShipmentServiceMethod",
                    "kind": "LinkedField",
                    "name": "serviceMethod",
                    "plural": false,
                    "selections": [
                      (v14/*:: as any*/),
                      (v15/*:: as any*/),
                      (v17/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v17/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Shipment",
                "kind": "LinkedField",
                "name": "shipment",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "shippingAddress",
                    "plural": false,
                    "selections": [
                      (v16/*:: as any*/),
                      (v17/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v17/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v17/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/581.0.0-2026-10-16T16:50:05.386Z/SharedContactDealerWrapperRefetchQuery",
    "metadata": {},
    "name": "SharedContactDealerWrapperRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6439ac00fc5e4c664cdd0871fdd615aa";

export default node;
